import { useState, useEffect } from "react";
const useFirestoreCollQuery = ref => {
  const [docState, setDocState] = useState({
    loading: true,
    data: null
  });

  // useEffect(() => {
  //   return ref.onSnapshot(docs => {
  //     setDocState({
  //       loading: false,
  //       data: docs
  //     });
  //   });
  // }, []);

  useEffect(() => {
    const unsubscribe = ref.onSnapshot(docs => {
      setDocState({
        loading: false,
        data: docs
      });
    });
    // unsubscribe to the listener when unmounting
    return () => unsubscribe();
  }, []);

  return docState;
};

export default useFirestoreCollQuery;
